import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { Skeleton } from '@/shared/ui';

import { useSession } from '../queries/useSession';

/**
 * Brama tras chronionych.
 *
 * ⚠ Trzy stany, nie dwa. „Jeszcze nie wiem, kto to" MUSI być odróżnione
 * od „nikt nie jest zalogowany" — bez tego przy każdym odświeżeniu strony
 * użytkownik dostaje przebłysk ekranu logowania, zanim wróci `/auth/me`.
 *
 * Adres, z którego przyszedł, jedzie w stanie nawigacji, żeby po zalogowaniu
 * wrócić dokładnie tam (spec 4A: każdy istotny stan ma udostępnialny URL,
 * więc link z Jiry musi działać także dla niezalogowanego).
 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const location = useLocation();
  const { data: user, isPending } = useSession();

  if (isPending) {
    return (
      <div style={{ padding: 'var(--space-5)' }}>
        <Skeleton height="1.5rem" width="220px" announce />
      </div>
    );
  }

  if (!user) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: `${location.pathname}${location.search}` }}
      />
    );
  }

  return <>{children}</>;
}
